import { LevelActionType } from '~/bootcamp/types/bootcamp.types'

export default function getBootcampLevelPage(page: LevelActionType): LevelActionType {
  switch (page) {
    case LevelActionType.Activity:
      return LevelActionType.How
    case LevelActionType.Definition:
      return LevelActionType.Definition
    default:
      return page
  }
}
